import React from "react";
import { useState } from "react";
import './TextInput.css';

interface TextInputProps {
  defaultText: string,
  inputState: string,
  setInputState: Function
}

const TextInput: React.FC<TextInputProps> = ({defaultText, inputState, setInputState}) => {

  // make a function to use defaultText to determine styling of text color
  const styling = {
    color: inputState == defaultText ? '#d9d8d670' : undefined,
  }
  
  return (
    <input className="TextInputWrapper"
    id = {defaultText}
    type="text"
    value={inputState}
    onFocus={() => inputState == defaultText ? setInputState('') : undefined}
    onBlur={() => inputState == '' ? setInputState(defaultText) : undefined}
    onChange={event => setInputState(event.target.value)}
    style={styling}
    />
  )
}
export default TextInput